import {
  Component,
  ElementRef,
  Input,
  Output,
  OnInit,
  TemplateRef,
  EventEmitter,
  ViewChild,
  OnDestroy,
} from '@angular/core';

import { Subscription, filter } from 'rxjs';

import { PopoverDirective, PopoverOptions } from '@fcom/ui-components';
import { unsubscribe } from '@fcom/core/utils';

import { SelectorType } from '../../interfaces';
import { BookingWidgetService } from '../../services/booking-widget.service';
type Position = 'left' | 'right';

interface DoubleParams {
  readonly label: string;
  readonly placeholder: string;
  readonly filled: boolean;
}

@Component({
  selector: 'fin-booking-widget-selector',
  templateUrl: 'booking-widget-selector.component.html',
  styleUrls: ['./booking-widget-selector.component.scss'],
})
export class BookingWidgetSelectorComponent implements OnInit, OnDestroy {
  @Input()
  widgetType: SelectorType;

  @Input()
  disabled = false;

  @Input()
  label?: string;

  @Input()
  ariaLabel?: string;

  @Input()
  double?: {
    first: DoubleParams;
    second: DoubleParams;
  };

  @Input()
  position?: Position;

  @Input()
  filled?: boolean;

  @Input()
  placeholder?: string;

  @Input()
  popoverOptions: PopoverOptions;

  @Input()
  popoverContent: TemplateRef<ElementRef>;

  @Output()
  close = new EventEmitter<void>();

  usePopover: boolean;
  subscription = new Subscription();

  @ViewChild(PopoverDirective) popoverDirective: PopoverDirective;

  constructor(private bookingWidgetService: BookingWidgetService) {}

  ngOnInit(): void {
    this.usePopover = Boolean(
      this.bookingWidgetService.usePopoverSelectors() && this.popoverContent && this.popoverOptions
    );

    if (this.usePopover) {
      this.subscription.add(
        this.bookingWidgetService.modifyType$?.pipe(filter(Boolean)).subscribe((modifyType) => {
          if (modifyType === this.widgetType && this.popoverDirective) {
            this.popoverDirective.togglePopover();
          }
        })
      );
    }
  }

  handlePopoverClose(): void {
    this.close.emit();
    this.bookingWidgetService.resetModifyType();
  }

  ngOnDestroy(): void {
    unsubscribe(this.subscription);
  }
}
